export const heatmapsFeatures = {
    summary: {
        name: 'Heatmaps',
        description: 'Visualize where users click and scroll on your website',
        url: '/session-replay/heatmaps',
        docsUrl: '/docs/session-replay/heatmaps',
    },
    features: {
        clickmaps: {
            name: 'Clickmaps',
            description: 'See what elements people click on in pages',
        },
        heatmaps: {
            name: 'Heatmaps',
            description: 'See clicks and mouse movement on your site',
        },
        movement_maps: {
            name: 'Movement maps',
            description: 'Visualize mouse movements',
        },
        rage_clicks: {
            name: 'Rage clicks',
            description: 'Track repeated clicks in the same place',
        },
        rage_taps: {
            name: 'Rage taps',
            description: 'Identify repetitive taps made out of frustration',
        },
        dead_taps: {
            name: 'Dead taps',
            description: 'Detect taps on elements that do not respond or trigger an action',
        },
        scrollmaps: {
            name: 'Scrollmaps',
            description: 'Visualize how far users scroll on your website',
        },
        save_heatmaps: {
            name: 'Save heatmaps',
            description: 'Save historic heatmaps',
        },
        toolbar: {
            name: 'Toolbar',
            description: 'View heatmaps overlaid directly on a webpage',
        },
    },
}
